import * as React from "react";
import { cn } from "./utils";

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    children?: React.ReactNode;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, children, ...props }, ref) => {
    return (
        <label ref={ref} className={cn("text-md text-slate-700 dark:text-slate-200", className)} {...props}>
            {children}
        </label>
    );
});
Label.displayName = "Label";
